/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let isSyncing = false;
    let debounceTimer;

    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    this.minInput = amounts.querySelector('.field__input_min');
    this.maxInput = amounts.querySelector('.field__input_max');
    this.realInput = amounts.querySelector('input[type=hidden]');
    this.form = amounts.closest('form');
    this.isSubmitAllAtOnce = (this.form.id == 'graphene-filter-all');
    this.base_url = amounts.dataset.url ?? window.location.href;

    /*const _this = this;*/

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', (values) => {
      if (isSyncing) return;
      isSyncing = true;

      this.minInput.value = values[0];
      this.maxInput.value = values[1];

      isSyncing = false;
    });

    this.minInput.addEventListener(
      'input',
      debounce(() => {
        if (isSyncing) return;
        isSyncing = true;
        slider.noUiSlider.set([this.minInput.value, null]);
        this.updateFilter();
        isSyncing = false;
      }, 1000)
    );
    this.maxInput.addEventListener(
      'input',
      debounce(() => {
        if (isSyncing) return;
        isSyncing = true;
        slider.noUiSlider.set([null, this.maxInput.value]);
        this.updateFilter();
        isSyncing = false;
      }, 1000)
    );

    slider.noUiSlider.on('change', (values) => {
      this.updateFilter();
      //form.querySelector('form').dispatchEvent(event);
    });
  }
  updateFilter() {
    let new_val = `${this.minInput.value}-${this.maxInput.value}`;
    if(this.isSubmitAllAtOnce){
      this.realInput.value = new_val;
    }
    else {
      let submit_url = new URL(this.base_url, window.location.origin);
      submit_url.searchParams.set(this.realInput.name, new_val);
      collectionFilterFocus=null;
      graphenehc.reload({url: submit_url.href});
    }
  }
}
customElements.define('price-slider', PriceSlider);
